module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('article', {
    staticClass: "view__content"
  }, [_c('div', {
    staticClass: "view__panel"
  }, [_c('div', {
    staticClass: "form js-form"
  }, [(this.$route.params.id) ? _c('submenu') : _vm._e(), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Settings_Group_Name",
      "validate": _vm.$v,
      "modelPath": "name",
      "acc": "name"
    },
    on: {
      "input": _vm.$v.name.$touch
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('TextBox', {
    attrs: {
      "label": "Settings_Group_Description",
      "validate": _vm.$v,
      "modelPath": "description",
      "multiLine": true,
      "acc": "description"
    },
    on: {
      "input": _vm.$v.description.$touch
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  }), _vm._v(" "), _c('Btn', {
    attrs: {
      "isLoading": _vm.loading,
      "label": "Label_SaveButton"
    },
    on: {
      "click": _vm.save
    }
  }), _vm._v(" "), _c('Btn', {
    attrs: {
      "label": "Label_CancelButton",
      "withBorder": true
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'groups'
        })
      }
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f96e24b2!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/groups/Group.vue
// module id = 769
// module chunks = 1